// extracted by mini-css-extract-plugin
module.exports = {"webViewerContainer":"PDFDocument_webViewerContainer__1de9J","webViewer":"PDFDocument_webViewer__OXg_I"};